'use client'
import React from 'react'
import Phone from 'react-phone-input-2'
/* prettier-ignore  */ // prettier-ignore for disable auto-sorting styles when save, order is important
import 'react-phone-input-2/lib/style.css'
/* prettier-ignore  */
import 'react-phone-input-2/lib/bootstrap.css'
/* prettier-ignore  */
import './styles.scss'
/* prettier-ignore  */
import styles from './styles.module.scss'
/* prettier-ignore  */
import HelperButton from '../HelperButton'
import { InputProps } from '../types'

interface PhoneInputProps extends InputProps {
  country?: string
  errorWhenEmpty?: boolean
  countryCodeEditable?: boolean
  errors?: boolean
}

const PhoneInput: React.FC<PhoneInputProps> = ({
  country,
  placeholder,
  name,
  labelText,
  helperButton,
  tooltip,
  id,
  isDisabled,
  errorWhenEmpty = false,
  countryCodeEditable = false,
  errors,
  ...props
}) => {
  // const [invalid, setInvalid] = useState('')

  return (
    <div
      className={`${styles.inputWrapper} ${
        (errorWhenEmpty && !props.value) || errors ? styles.error : ''
      }`}
    >
      {/* {labelText && <Label htmlFor={name}>{labelText}</Label>} */}
      <div>
        <Phone
          red
          country={country}
          name={name}
          countryCodeEditable={countryCodeEditable}
          disableDropdown={!countryCodeEditable}
          placeholder={labelText || placeholder}
          {...(props as any)}
          disabled={isDisabled}
          enableSearch={true}
        />
        {helperButton && <HelperButton {...helperButton} tooltip={tooltip} />}
        {/*{props.value && invalid && <ErrorText>{invalid}</ErrorText>}*/}
      </div>
    </div>
  )
}

export default PhoneInput
